/* global Packery */

import PhotoSwipeLightbox from "./photoswipe/photoswipe-lightbox.esm";
import PhotoSwipe from "./photoswipe/photoswipe.esm.js";

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onReady
 * @return {void}
 */
const domReady = (onReady) => {
	if (document.readyState !== "loading") {
		// Document is already ready, call the callback directly
		onReady();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener("DOMContentLoaded", onReady);
	} else {
		// Old IE browsers
		document.attachEvent("onreadystatechange", function () {
			if (document.readyState === "complete") {
				onReady();
			}
		});
	}
};

const App = {
	init() {
		console.log("Started...");

		var elem = document.querySelector(".projects-grid");
		var pckry = new Packery(elem, {
			itemSelector: ".projects-grid-item",
			percentPosition: true,
		});

		const images = [
			{
				id: 1,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+1",
				width: 1500,
				height: 1000,
			},
			{
				id: 2,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+2",
				width: 1500,
				height: 1000,
			},
			{
				id: 3,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+3",
				width: 1500,
				height: 1000,
			},
			{
				id: 4,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+4",
				width: 1500,
				height: 1000,
			},
			{
				id: 5,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+5",
				width: 1500,
				height: 1000,
			},
			{
				id: 6,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+6",
				width: 1500,
				height: 1000,
			},
			{
				id: 7,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+7",
				width: 1500,
				height: 1000,
			},
			{
				id: 8,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+8",
				width: 1500,
				height: 1000,
			},
			{
				id: 9,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+9",
				width: 1500,
				height: 1000,
			},
			{
				id: 10,
				src: "https://dummyimage.com/1500x1000/555/fff/?text=Image+10",
				width: 1500,
				height: 1000,
			},
		];

		const projectGalleries = document.querySelectorAll("[data-gallery]");
		[...projectGalleries].map((gallery, index) => {
			const dataSrc = JSON.parse(gallery[0].dataset.src);
			if (dataSrc.length) {
				const lb = new PhotoSwipeLightbox({
					dataSource: dataSrc,
					index: 0,
					pswpModule: () => PhotoSwipe,
				});
				lb.init();

				gallery[0].addEventListener(
					"click",
					(event) => {
						lb.loadAndOpen(0);
					},
					false
				);
			}
		});

		// expose to use within onclick attribute
		// window.pswpLightbox = lightbox;
	},
};

domReady(() => {
	App.init();
});
